import React from "react";

// MUI
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
export default function BasicModal({ open, onClose, title, children, onSubmit, submitLabel = 'Save', disableSubmit = false, maxWidth = 'sm' }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={maxWidth} scroll="paper">
      <form onSubmit={async (e) => { e.preventDefault(); if (onSubmit) await onSubmit(); }}>
        <DialogTitle
          sx={(theme) => ({
            position: 'sticky',
            top: 0,
            zIndex: 2,
            borderBottom: `1px solid ${theme.palette.divider}`,
            fontWeight: 600,
            fontSize: 22,
            letterSpacing: 1,
            paddingBottom: 1,
            background: theme.palette.background.paper,
          })}
        >
          {title}
        </DialogTitle>
        <DialogContent
          dividers
          sx={(theme) => ({
            maxHeight: '70vh',
            overflowY: 'auto',
            background: theme.palette.background.paper,
            scrollbarWidth: 'thin',
          })}
        >
          {children}
        </DialogContent>
        <DialogActions
          sx={(theme) => ({
            position: 'sticky',
            bottom: 0,
            borderTop: `1px solid ${theme.palette.divider}`,
            zIndex: 2,
            background: theme.palette.background.paper,
            display: 'flex',
            justifyContent: 'space-between',
          })}
        >
          <Button key='cancelButton' onClick={onClose} variant="outlined">Cancel</Button>
          <span style={{ flex: 1 }} />
          <Button key='submitButton' type="submit" color="primary" variant="contained" disabled={!!disableSubmit}>
            {submitLabel}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}